import { useTranslation } from "react-i18next";
import { RatingForm } from "@/components/backOffice/ratings/RatingForm";

export const RatingPage = () => {
  const { t } = useTranslation("boRatings");

  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-4 p-8">
      <div className="flex flex-col gap-2">
        <h1 className="font-jakarta-sans text-3xl font-semibold">{t("page.title")}</h1>
        <p>{t("page.description")}</p>
      </div>
      <RatingForm />
    </div>
  );
};
